var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNucleus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3776 48.0419C50.9585 44.8997 54.5567 36.207 51.4144 28.6263C48.2721 21.0456 39.5793 17.4474 31.9984 20.5897C24.4175 23.7319 20.8193 32.4246 23.9616 40.0053C27.1039 47.586 35.7967 51.1842 43.3776 48.0419Z",
    fill: "#F30002"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9386 20.136C58.7554 20.136 61.0471 17.8444 61.0471 15.0275C61.0471 12.2107 58.7554 9.91907 55.9386 9.91907C53.1218 9.91907 50.8301 12.2107 50.8301 15.0275C50.8301 17.8444 53.1217 20.136 55.9386 20.136Z",
    fill: "#161614"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7111 14.5374C27.046 11.2528 32.2207 9.51653 37.6755 9.51653C41.6211 9.51653 45.3934 10.4158 48.8874 12.1894L50.4792 9.05376C46.4873 7.02741 42.1794 6 37.6755 6C31.4475 6 25.5385 7.98297 20.5873 11.7346C15.7983 15.3635 12.2234 20.5181 10.5215 26.2492L13.8927 27.2503C15.3828 22.232 18.5146 17.7172 22.7111 14.5374Z",
    fill: "#161614"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2042 20.1531L59.1608 21.915C61.3346 25.6697 62.4836 29.9607 62.4836 34.3242C62.4836 39.779 60.7473 44.9535 57.4626 49.2885C54.2828 53.4849 49.7678 56.6166 44.7495 58.1068L45.7505 61.4778C51.4818 59.776 56.6366 56.2013 60.2655 51.4122C64.0172 46.4611 66.0002 40.5521 66.0002 34.3242C66.0002 29.3428 64.6875 24.4425 62.2042 20.1531Z",
    fill: "#161614"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8926 41.3958L10.5215 42.3968C11.8547 46.8867 14.3192 51.0197 17.6486 54.3489C20.9779 57.6781 25.1109 60.1426 29.6009 61.4759L30.602 58.1048C26.6714 56.9375 23.052 54.779 20.1352 51.8622C17.2185 48.9455 15.0598 45.3263 13.8926 41.3958Z",
    fill: "#161614"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6739 55.7832C34.8571 55.7832 32.5654 58.0748 32.5654 60.8917C32.5654 63.7084 34.8571 66.0001 37.6739 66.0001C40.4907 66.0001 42.7824 63.7085 42.7824 60.8917C42.7824 58.0748 40.4907 55.7832 37.6739 55.7832Z",
    fill: "#161614"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1086 39.432C13.9299 39.432 16.2171 37.1449 16.2171 34.3236C16.2171 31.5022 13.9299 29.2151 11.1086 29.2151C8.28718 29.2151 6 31.5022 6 34.3236C6 37.1449 8.28718 39.432 11.1086 39.432Z",
    fill: "#161614"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNucleus);
export default __webpack_public_path__ + "static/media/nucleus.5b55a6ff58488859e160c2e4ce33598a.svg";
export { ForwardRef as ReactComponent };